import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  UtilityBillsTableRow,
  EmptyStateContainer,
  Loader
} from '../../../../neoverv';
import tap from '../../../../assets/images/module/general/TapIconDark.svg';
import moment from 'moment';
import { setTenantBills } from '../../../../redux/action/UtilityBilling/UtilityBillingActions';
import Autoload from '../../../../neoverv/Autoload';
import { isStarterTier, isPremiumTier } from '../../../../helpers/subscriptionFeatureAccess';
// import Logo from '../../../../assets/images/module/general/Logo.svg';
import html2canvas from 'html2canvas';
import imageCompression from 'browser-image-compression';
import jsPdf from 'jspdf';
//import Html from 'react-pdf-html';
import { PDFDownloadLink, Document, Page } from 'react-pdf';
import { browserName } from "react-device-detect";

import $ from 'jquery';
import {
  Table, 
  TableBody, 
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@material-ui/core';
import { showNotification } from '@mantine/notifications';
import RedCross from '../../../../assets/images/module/general/RedCross.svg';
import GreenTick from '../../../../assets/images/module/general/GreenTick.svg';
// import MeterIcon from '../../../../assets/images/module/general/blueEmptyMeter.svg';
import MeterReadingsTableRow from '../../../../routes/meter/reading/TableRow';
import { Group, Stack } from '@mantine/core';
import { formatNumber, formatUnit } from '../../../../helpers/stringsManipulations';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib'
import EmptyState from '../../../../neoverv/components/EmptyState';
import { icon } from '@fortawesome/fontawesome-svg-core';

import MovedInIcon from '../../../../assets/images/module/general/MovedInIcon.svg';
import MovedOutIcon from '../../../../assets/images/module/general/MovedOutIcon.svg';
import CalendarIcon from '../../../../assets/images/module/general/CalendarIcon.svg';
import EmptyApartmentIcon from '../../../../assets/images/module/general/emptyApartmentIcon2.svg';
import accounting from 'accounting';
import { getPdfDefaultLogo, getPdfLogoWidth } from '../../../../helpers/pdfBranding';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
const { yearDifferenceMoment, checkProperty, loader, checkEnvironment, errorHandlingForPDF } = Autoload.MainHelper;
const MOBILE_SIZE = 766;
let allBills = [];
const ref = React.createRef();
const btnRef = React.createRef();

const Logo = "data:image/svg+xml;base64,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";
const MeterIcon = "data:image/svg+xml;base64,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";

const tableBodyCellStyling = {
    color: 'rgb(17, 17, 71)',
    padding: '1mm',
    fontWeight: '500',
    whiteSpace: 'wrap',
    fontSize: '7pt',
    lineHeight: '20px',
    border: '1px solid #DADAE6',
    fontFamily: 'Inter, sans-serif',
    height: '0px',
    minWidth: '40px'
  }

export class MeterReadingsTemplate extends Component {
  static propTypes = {
    prop: PropTypes,
  };

  tableHeadCellStyling = {
    color: 'black',//'#727293',
    padding: '0px 3px',
    fontWeight: '500',
    whiteSpace: 'nowrap',
    margin: '0px',
    fontSize: '7pt',
    lineHeight: '20px',
    border: '1px solid #DADAE6',
    textTransform: 'capitalize',
    height: '0px',
    minWidth: '40px',
    borderBottom: 'none',
    borderRight: 'none',
    textAlign: 'left'
  }

  state = {
    selectedTenantID: '1',
    DropdownState: 'true',
    isMobile: window.innerWidth <= MOBILE_SIZE,
    showEmpty: true,
    utilityData: {
      date: '',
      recordStatus: 'last',
    },
    utilityBillTableData: null,
    selectedTenantData: null,
    invoiceData: null,

    readings: [],
    occupationReadings: null,
    files: [],
    count: 0,
    customImageBase64: null,
    allPdfs: []
  };

  allocationKey= '';
  allocationKeyValueTotal= 0;
  allocationKeyUnit= '';
  allocationCounter = 0;

  componentDidMount() {
    //loader(true);
    let url = new URL(window.location.href);
    console.log('searchParams: ', JSON.parse(url.searchParams.get("occupationReadings")));
    this.setState({occupationReadings: JSON.parse(url.searchParams.get("occupationReadings"))}, ()=> {
        const id = window.location.pathname.split('/')[2];
        if(this.props.companyLogoEnable === 'UserDefined'){
          this.getAccountPicture(id)
        }else{
          // Call refactored fetch function
          this.getOccupationReadings();
        }
    })//url.searchParams.get("readingsId").split(',')}, ()=> console.log('readingsId: ', this.state.readingsId));

    var loaderWhole = document.getElementById('hello-housing-loader');
    loaderWhole.style.display = 'block';
    var loaderBackground = document.getElementById('hh_loader_bg');
    var loader = document.getElementById('hh_loader_spinner');
    var progressBar = document.getElementById('hh_progress_bar');
    loaderBackground.style.background = 'white';
    loaderBackground.style.opacity = '1';
    loader.style.zIndex = '99999';

    var downloadStatus = document.getElementById('download_status');
    downloadStatus.style.display = 'block';
    downloadStatus.textContent=`PDF-Dokumente erstellen ${this.state.count} / ${JSON.parse(url.searchParams.get("occupationReadings")).length}`;

    // const id = window.location.pathname.split('/')[2]; // Moved inside setState callback above
    
    //this.props.companyLogoEnable ? this.getAccountPicture(id) : this.getOccupationReadings(id);

    
    // let data = this.props.utilityBillingData.find((ub) => ub.id == this.props.currentDataId);
    // if (this.props.tenantBills.length) {
    //   const selectedTenantData = this.props.tenantBills[0]?.billingData?.tenantBills[0];
    //   this.setState({ selectedTenantData });
    // }
    // console.log('data CDM', data);
    // let diff = yearDifferenceMoment(data.date.split('-')[0])
    // if (data !== undefined) {
    //   this.setState(
    //     {
    //       utilityData: {
    //         date: data && data.date ? data.date : '',
    //         recordStatus: data && data.recordStatus ? data.recordStatus : 'last',
    //       },
    //     },
    //     () => {
    //       this.updateConsumptions();
    //     }
    //   );
    // }

    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  // getAccountPicture=(id)=>{
  //   fetch(Autoload.Setting.account_api_baseurl + this.props.accountData.accountId +'/picture/download', 
  //   {
  //     method: 'GET',
  //     headers: {
  //       'Content-Type': 'octet-stream',
  //       'Authorization': Autoload.Utils.getAuthToken()
  //     }
  //   }).then(response => {
  //     response.blob()
  //     .then(blob => {
  //       console.log('getAccountPicture: ', blob);
  //       const url =URL.createObjectURL(blob);
  //       this.setState({customImageBase64: blob.size > 0 ? url : null});
  //       console.log('getAccountPicture: url:', url);
  //       this.getOccupationReadings(id);
  //       }).catch(e1=> {
  //         console.log('getAccountPicture: error1: ', e1);
  //         this.getOccupationReadings(id)
  //       })
  //   }).catch(e=> {
  //     console.log('getAccountPicture: error: ', e);
  //     this.getOccupationReadings(id)
  //   })
  // }

  getAccountPicture=(id)=>{
    fetch(Autoload.Setting.account_api_baseurl + this.props.accountData.accountId +'/picture/download', 
    {
      method: 'GET',
      headers: {
        'Content-Type': 'octet-stream',
        'Authorization': Autoload.Utils.getAuthToken()
      }
    }).then(response => {
      response.blob()
      .then(async blob => {
        const options = {
          maxSizeMB: 0.1,
          maxWidthOrHeight: 400,
          useWebWorker: true
        }
        try {
          let fileNew = new File([blob], "my_image.png",{type:"image/png", lastModified:new Date().getTime()});
          
          const compressedFile = await imageCompression(fileNew, options);
          console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
          console.log(`compressedFile size ${compressedFile.size / 1024} KB`); // smaller than maxSizeMB
          
          var reader = new FileReader();
          reader.readAsDataURL(compressedFile); 

          const setState=(base64)=>{
            this.setState({customImageBase64: base64 ? base64 : null}, ()=> this.getOccupationReadings());
          }
          
          reader.onloadend = function() {
            var base64data = reader.result;                
            console.log('base64data: ', base64data);
            setState(base64data);
          }
        } catch (error) {
          console.log('getAccountPicture: ', error);
          this.getOccupationReadings()
        }



        // console.log('getAccountPicture: ', blob);
        // const url =URL.createObjectURL(blob);
        // this.setState({customImageBase64: blob.size > 0 ? url : null});
        // console.log('getAccountPicture: url:', url);
        }).catch(e1=> {
          console.log('getAccountPicture: error1: ', e1);
          this.getOccupationReadings();
        })
    }).catch(e=> {
      console.log('getAccountPicture: error: ', e);
      this.getOccupationReadings();
    })
  }

  getInvoiceData = (id) => {
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.ub_api_base_url + 'billingStatements/' + id,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      '_handleGetInvoice',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };

  _handleGetInvoice = (response) => {
    console.log('get billing statement', response);
    if (response.status === false && response.message !== 'Not Found') {
      // Autoload.Redirection.redirection_error();
      Autoload.DataHandlerGeneral.GeneralErrorMessage(true, lang.newKeys.text_error_not_found);
    }
    this.setState({ invoiceData: response.result });
  };

  updateConsumptions = () => {
    // loader(true);
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.ub_api_base_url + 'updateConsumptions/' + this.props.currentDataId,
      'PUT',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleUpdateConsumptionsResponse',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };
  handleUpdateConsumptionsResponse = (response) => {
    !response.status && console.log('Update Consumptions Failed');

    //loader(false);
    // this.callApis();
  };

  getOccupationReadings = () => {
    const { occupationReadings } = this.state;
    // Extract unique occupation IDs from the URL params list
    const uniqueOccupationIds = [...new Set(occupationReadings.map(item => item.occupationId))];

    // Create fetch promises for each occupation ID
    const promises = uniqueOccupationIds.map(id =>
        fetch(Autoload.Setting.meter_api_base_url + 'occupationReadings/' + id, {
            method: 'GET',
            headers: {
                Authorization: Autoload.Utils.getAuthToken(),
            }
        }).then(res => res.json())
    );

    Promise.all(promises)
        .then(results => {
            // Filter out any failed requests or empty results
            const validResults = results
                .filter(r => r.status && r.result)
                .map(r => r.result);
            
            // Call the handler with the aggregated results
            // Note: _handleGetOccupationReadings expects response.result if passed a standard response object
            // or we can just pass the array if we adapt the handler or wrap it here.
            // Let's wrap it to match the expected signature { status: true, result: [...] }
            this._handleGetOccupationReadings({ status: true, result: validResults });
        })
        .catch(error => {
            console.error("Error fetching occupation readings:", error);
            showNotification({
                message: 'Bitte versuchen Sie es noch einmal.',
                icon: RedCross
            });
        });
  }

  _handleGetOccupationReadings = (response)=>{
    //console.log('_handleGetOccupationReadings: ', response);
    // Rearrange data to make it easier to use
    console.log('_handleGetOccupationReadings', response);
    if(response.status){
        response.result?.filter((data) => (
            (!data.vacant) || 
            (data.vacant && data.periodEndReading?.occasion === 'annual')
            || (data.vacant && data.periodEndReading?.occasion === 'move-in') 
          )).forEach((item, i) => {
            let findItem = this.state.occupationReadings.find((occupationReading)=> occupationReading.occupationId === item.id)
            console.log('findItem: ', findItem);
            if(findItem !== undefined){
              let {readings} = this.state;
              console.log(`ITEM ${i}: `, item);
              if (item.periodStartReading?.occasionDate >= item.periodStart && item.periodStartReading && (this.state.occupationReadings.find((occupationReading)=> occupationReading.readingsId === item.periodStartReading.id) !== undefined)) {
                //let editableLastIds = editableIds;
              //   if(item.periodStartReading && item.periodStartReading.occasion === 'move-in'){
              //     const { meterReadings } = item.periodStartReading;
              //     meterReadings.map((reading)=> (reading.startValue === null || reading.startValue === 0 || reading.startValue === '0,00') && editableLastIds.push(reading.id))
              //   }
                const periodReading = {
                  ...item.periodStartReading,
                  periodStart: item.periodStart,
                  periodEnd: item.periodEnd,
                  rentalUnitName: item.rentalUnitName,
                  tenantFullName: item.tenantFullName,
                  tenantId: item.tenantId,
                  occupationId: item.id,
                  vacant: item.vacant,
                  startReadingOccasion: item.periodStartReading?.occasion
                }
                readings.push(periodReading);
                this.setState({readings});
                //setEditableIds(editableLastIds);
              };
              if (item.periodEndReading && (this.state.occupationReadings.find((occupationReading)=> occupationReading.readingsId === item.periodEndReading.id) !== undefined)) {
                let { meterReadings } = item.periodEndReading;
                meterReadings= meterReadings.map((meterReading)=> {
                  const meterReadingsFromPeriodStartReading = item.periodStartReading.meterReadings.find((meterReading1)=> meterReading1.meter.id === meterReading.meter.id);
                  if(meterReadingsFromPeriodStartReading !== undefined){
                    meterReading.startValue = {
                      id:   meterReadingsFromPeriodStartReading.id,
                      value: meterReadingsFromPeriodStartReading.currentValue
                    };
                  }
                  meterReading.consumption = (meterReading.meter.hkaEvaluationFactor === null && (meterReading.currentValue === null || meterReading?.startValue?.value === null)) ? null : meterReading.currentValue - meterReading?.startValue?.value;
                  //((meterReading.currentValue === 0 || meterReading.currentValue) && (meterReading?.startValue?.value === 0 || meterReading?.startValue?.value)) ? meterReading.currentValue - meterReading?.startValue?.value : null;
                  return meterReading;
                });
                const periodReading = {
                  ...item.periodEndReading,
                  periodStart: item.periodStart,
                  periodEnd: item.periodEnd,
                  rentalUnitName: item.rentalUnitName,
                  tenantFullName: item.tenantFullName,
                  tenantId: item.tenantId,
                  occupationId: item.id,
                  vacant: item.vacant,
                  occasion: (item.vacant && item.periodEndReading?.occasion === 'move-in') ? 'empty-tenant-move-out' : item.periodEndReading?.occasion,
                  startReadingOccasion: item.periodStartReading?.occasion
                }
                readings.push(periodReading);
                this.setState({readings});
              };
            }
          });
    }else{
        showNotification({
            message: 'Bitte versuchen Sie es noch einmal.',
            icon: RedCross
        });
        setTimeout(() => {
            window.close();
        }, 5000);
    }
    setTimeout(() => {
      //this.printDocument(0, 1);  
      this.downloadPdfFromServer(0);
    }, 1000);
      //this.printDocumentMultiplePages();
  }

  callApis = (id) => {
    // loader(true);
    allBills = [];
    //get all billing statements
    Autoload.HttpRequestAxios.HttpRequest(
      // Autoload.Setting.swagger_mocked_api_baseUrl +
      //   'billingStatements?offset=0&results=10&utilityBillingId=' +
      //   this.props.currentDataId,
      Autoload.Setting.ub_api_base_url + 'billingStatements/' + id,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      '_handleGetBS',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };
  _handleGetBS = (response) => {
    console.log('response1 Billing Statement', response);
    if (response.status === false && response.message !== 'Not Found') {
      // Autoload.Redirection.redirection_error();
      Autoload.DataHandlerGeneral.GeneralErrorMessage(true, lang.newKeys.text_error_not_found);
      loader(false);
    }
    if (response.result) {
      const bs = response.result;
      let data = {
        tenantID: checkProperty(bs, 'tenantId'),
        tenantName: checkProperty(bs, 'tenantName'),
        stayedFor: checkProperty(checkProperty(bs, 'tenantOccupation'), 'totalDays'),
        totalAllocations: checkProperty(bs, 'totalAllocatedUtilityCosts'),
        prepayments: checkProperty(bs, 'totalAdvancePayments'),
        billingStatementId: checkProperty(bs, 'id'),
        utilityBillingId: checkProperty(bs, 'utilityBillingId'),
        rentalUnitId: checkProperty(bs, 'rentalUnitId'),
        tenantOccupation: checkProperty(bs, 'tenantOccupation'),
      };
      const billingId = checkProperty(bs, 'billingStatementId')
        ? checkProperty(bs, 'billingStatementId')
        : checkProperty(bs, 'id');
      //get pdf for each record
      this._handleGetBSpdf(data.utilityBillingId, billingId);
      this.setState({ invoiceData: response.result });
    } else {
      //store empty array to tenantBills field of redux
      this.props.setTenantBills(allBills);
      this.setState({ showEmpty: false });
      //loader(false);
    }
  };

  _handleGetBSpdf = (ubId, bsId) => {
    let url = new URL(window.location.href);
    var heatingFilter = url.searchParams.get("heatingFilter");
    console.log('_handleGetBSpdf: ', heatingFilter);
    //call apis for tenantRows
    heatingFilter === 'true' ?
    Autoload.HttpRequestAxios.HttpRequest(
      // Autoload.Setting.swagger_mocked_api_baseUrl +
      //   'costAllocations/forBillingStatement?utilityBillingId=' +
      //   response.other.BSData.utilityBillingId +
      //   '&billingStatementId=' +
      //   response.other.BSData.billingStatementId,
      Autoload.Setting.ub_api_base_url +
        'costAllocations/forBillingStatement?utilityBillingId=' +
        ubId +
        '&billingStatementId=' +
        bsId,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      '_handleGetBSRows',
      {},
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    )
    : 
    Autoload.HttpRequestAxios.HttpRequest(
      // Autoload.Setting.swagger_mocked_api_baseUrl +
      //   'costAllocations/forBillingStatement?utilityBillingId=' +
      //   response.other.BSData.utilityBillingId +
      //   '&billingStatementId=' +
      //   response.other.BSData.billingStatementId,
      Autoload.Setting.ub_api_base_url +
        'costAllocations/forBillingStatement?utilityBillingId=' +
        ubId +
        '&billingStatementId=' +
        bsId +
        '&filter=non-heating',
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      '_handleGetBSRows',
      {},
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    )
  };
  _handleGetBSRows = (response) => {
    console.log('response2 forBillingStatement', response);
    let formattedResponse = [];
    if (response.status === false) {
      // Autoload.Redirection.redirection_error();
      //Autoload.DataHandlerGeneral.GeneralErrorMessage(true, lang.newKeys.text_error_not_found);
      loader(false);
      showNotification({
        //title:'Fehler',
        message: 'Es gibt noch keine Betriebskostenabrechnung.',
        icon: <img src={RedCross} alt='red-tick'/>,
      })
    }

    if (response.result.length > 0) {
      console.log('formattedResponse', formattedResponse);
      formattedResponse = response.result.map((tr) => ({
        // id: checkProperty(tr, 'id'),
        id: checkProperty(tr, 'id'),
        costType: checkProperty(tr, 'costTypeName'),
        totalCost: checkProperty(tr, 'totalCostShare'),
        allocationKey: checkProperty(tr, 'allocationTypeName'),
        totalValue: checkProperty(tr, 'totalConsumption'),
        tenantValue: checkProperty(tr, 'tenantConsumption'),
        unit: checkProperty(tr, 'consumptionUnits'),
        tenantCostShare: checkProperty(tr, 'tenantCostShare'),
        comment: checkProperty(tr, 'comment'),
        utilityBillingId: checkProperty(tr, 'utilityBillingId'),
        costPositionId: checkProperty(tr, 'costPositionId'),
        billingStatementId: checkProperty(tr, 'billingStatementId'),
        tenantName: checkProperty(tr, 'tenantName'),
        rentalUnitId: checkProperty(tr, 'rentalUnitId'),
        rentalUnitName: checkProperty(tr, 'rentalUnitName'),
        tenantOccupation: checkProperty(tr, 'tenantOccupation'),
        costTypeIdentifier: checkProperty(tr, 'costTypeIdentifier')
      }));

      //merge data in array
      // allBills.push(mergedData);
      // const data = allBills.find((ub) => ub.utilityBillingId == this.props.currentDataId);
      // console.log('allBills', allBills, mergedData, this.props.currentDataId, data);
      // this.props.setTenantBills(allBills);
      // const { allTenantBills } = this.getAllData();

      // loader(true);
      this.setState(
        {
          selectedTenantData: { ...this.state.selectedTenantData, tenantRows: formattedResponse },
        },
        () => {
          //loader(false)
          // btnRef.current.click()
          // this.printDocument();
          this.downloadPdfFromServer(0);
        }
      );
    } else {
      // loader(false);
    }
  };

  getTableLabels = (end) => {
    return (
      <TableRow>
        <TableCell style={{...this.tableHeadCellStyling}}>Zählernummer</TableCell>
        <TableCell style={{...this.tableHeadCellStyling}}>Bezeichnung</TableCell>
        <TableCell style={this.tableHeadCellStyling}>Zählertyp</TableCell>
        <TableCell style={this.tableHeadCellStyling}>Standort</TableCell>
        {!end && <TableCell style={{...this.tableHeadCellStyling, ...{textAlign: 'right'}}}>Startwert</TableCell>}
        <TableCell style={{...this.tableHeadCellStyling, ...{textAlign: 'right'}}}>Ablesewert</TableCell>
        {!end && <TableCell style={{...this.tableHeadCellStyling, ...{textAlign: 'right'}}}>Verbrauch</TableCell>}
        <TableCell style={{...this.tableHeadCellStyling, ...{minWidth: '20px'}}}>Einheit</TableCell>
        <TableCell style={this.tableHeadCellStyling}>Notiz</TableCell>
        {end &&
        <>
          <TableCell style={{...this.tableHeadCellStyling, ...{borderLeft: 'none', borderRight: 'none'}}}/>
          <TableCell style={{...this.tableHeadCellStyling, ...{borderLeft: 'none'}}}/>
        </>
        }
      </TableRow>
    );
  };
  getAllData = () => {
    console.log('get All data func ');
    const { utilityBillingData } = this.props;
    let currentBillingData = utilityBillingData.find((ub) => ub.id == this.props.currentDataId);
    let allTenantBills =
      currentBillingData &&
      currentBillingData.billingData &&
      currentBillingData.billingData.tenantBills &&
      currentBillingData.billingData.tenantBills;
    let currentTenant =
      Array.isArray(allTenantBills) &&
      allTenantBills.find((tb) => tb.billingStatementId == this.state.selectedTenantID);
    // console.log('getData', allTenantBills, currentTenant)
    return {
      currentTenant: currentTenant ? currentTenant : {},
      allTenantBills: Array.isArray(allTenantBills) && allTenantBills.length > 0 ? allTenantBills : [],
    };
  };

  updateCommentLocalState = (tenantId, billId, value) => {
    // loader(true);
    this.setState({
      utilityBillTableData: {
        ...this.state.utilityBillTableData,
        tenantRows: this.state.utilityBillTableData.tenantRows.map((i) =>
          i.id === billId ? { ...i, comment: value } : i
        ),
      },
    });
  };

  downloadPDF = (file) => {
    window.open(file, '_blank');
  };
  calculateBalance = (data) => {
    const { totalAllocations, prepayments } = data.currentTenant;
    return parseFloat(totalAllocations) - parseFloat(prepayments);
  };
  getBalance(data) {
    var totalAllocations = checkProperty(data, 'totalAllocations', '-');
    var prePayments = checkProperty(data, 'prepayments', '-');
    // console.log(data)
    // console.log(totalAllocations)
    // console.log(prePayments)
    var getbalance = totalAllocations - prePayments + '€';
    return getbalance === 'NaN€' ? '-' : getbalance;
  }
  handleResize = () => {
    window.innerWidth <= MOBILE_SIZE ? this.setState({ isMobile: true }) : this.setState({ isMobile: false });
  };
  onInputChange = (field, value) => {
    const selectedTenantData = this.props.tenantBills[0]?.billingData?.tenantBills?.filter(
      (o) => o.tenantID === value
    )[0];
    // console.log(selectedTenantData)
    this.setState({ [field]: value, selectedTenantData }, () => console.log(this.state.selectedTenantData));
  };

  printOccasion = (slug) => {
    switch (slug) {
      default: case 'annual':
        return 'Jahresablesung';
      case 'move-in':
        return 'Einzug';
      case 'move-out':
        return 'Auszug';
      case 'empty-tenant-move-out':
        return 'Leerstand';
    }
  }

  renderOccasionIcon = (occasionName) => {
    switch (occasionName) {
      case 'Moved in':
      case 'move-in':
        return MovedInIcon;
      case 'Moved out':
      case 'move-out':
        return MovedOutIcon;
      case 'Annual':
      case 'annual':
        return CalendarIcon;
      case 'empty-tenant-move-out':
        return EmptyApartmentIcon;
      default:
        break;
    }
  };

async printDocument(index, count) {
    const {readings, occupationReadings, customImageBase64} = this.state;
    var downloadStatus = document.getElementById('download_status');
    let {files} = this.state;
    let propertyName = this.props.currentProperty.name;
    let delay = readings.length <= 1 ? (2 * 1000) : readings.length * 1000;
    const logo = document.getElementById('logo');

    const logoWidth = this.props.companyLogoEnable === 'UserDefined' ? this.props.accountData.pictureLocation !== null ? logo.offsetWidth : getPdfLogoWidth(logo) : getPdfLogoWidth(logo);
    const logoHeight = this.props.companyLogoEnable === 'UserDefined' ? this.props.accountData.pictureLocation !== null ? logo.offsetHeight : 38 : 38;

    const emptyLogo = document.getElementById('emptyLogo');
    console.log('printDocument');
    const closeWindow = ()=> {
      var allowDownloadSafari = document.getElementById('allow_download');
      allowDownloadSafari.style.display = browserName === 'Safari' && 'block'; 
      var spinner = document.getElementById('hh_loader_spinner');
      browserName !== 'Safari' ? loader(false) : spinner.style.display = 'none';
      browserName !== 'Safari' && window.close();
    }
    const printOccasion = (slug) => {
      switch (slug) {
        default: case 'annual':
          return 'Jahresablesung';
        case 'move-in':
          return 'Einzug';
        case 'move-out':
          return 'Auszug';
      }
    }
    let input = document.getElementById(`divToPrint${index}`);
    let printOccassion = this.printOccasion(readings[index]?.occasion);
    if(index !== readings.length){
        if(occupationReadings.find((occupationReading)=> occupationReading.readingsId === readings[index].id && occupationReading.occupationId === readings[index].occupationId)){
            await html2canvas(logo, {
                scale: 4
              }).then(async(canvas) => {
                const imgData = this.props.companyLogoEnable === 'UserDefined' ? (customImageBase64 !== null ? customImageBase64 : canvas.toDataURL('image/png'))  : canvas.toDataURL('image/png');
                var doc = new jsPdf("p", "pt", 'a4');
                doc.addImage(imgData, 'JPEG',21, 20, logoWidth, logoHeight, undefined, 'NONE');
                /////////////////////
                doc.setFontSize(8);
                var text = `${this.props.accountData.addressCompany && (this.props.accountData.addressCompany + ', ')}${this.props.accountData.addressStreet && (this.props.accountData.addressStreet + ',')} ${(this.props.accountData.addressZipCode)} ${this.props.accountData.addressCity}`,
                xOffset = doc.internal.pageSize.width/2; 
                var pageSize = doc.internal.pageSize;
                var pageHeight = pageSize.height
                  ? pageSize.height
                  : pageSize.getHeight();
                
                doc.setTextColor('#828282');
                isPremiumTier(this.props.currentSubscription) && doc.text(text, 
                xOffset, 
                pageHeight - 30,
                {align: 'center'});
                /////////////////////
                readings[index].meterReadings.length === 0 ?
                await html2canvas(emptyLogo, {
                    scale: 4
                }).then((canvas1)=>{
                    const imgData1 = canvas1.toDataURL('image/png');
                    doc.addImage(imgData1, 'JPEG',290, 210, 10,10, undefined, 'NONE');
                    doc.html(input, {
                        callback: async function (doc) {
                          downloadStatus.textContent=`PDF-Dokumente erstellen ${count > occupationReadings.length ? occupationReadings.length : count} / ${occupationReadings.length}`;
                          await files.push(doc.output('arraybuffer'));      
                          
                          // doc.save(`${readings[index]?.rentalUnitName}-${readings[index]?.tenantFullName}-${printOccassion}.pdf`, {returnPromise: true})
                          // .then(
                          //   setTimeout(() => {
                          //     //index === (readings.length - 1) && closeWindow();
                          // }, delay))
                        },
                        margin: [0,10,0,10],
                        x: 10,
                        y: 15,
                        autoPaging: 'text',
                        html2canvas: {useCORS: true, scale: 0.505
                          , height: 0 },
                      })
                })
                :
                doc.html(input, {
                    callback: async function (doc) {
                      downloadStatus.textContent=`PDF-Dokumente erstellen ${count > occupationReadings.length ? occupationReadings.length : count} / ${occupationReadings.length}`;
                      await files.push(doc.output('arraybuffer'));      
                      
                      // doc.save(`${readings[index]?.rentalUnitName}-${readings[index]?.tenantFullName}-${printOccassion}.pdf`, {returnPromise: true})
                      // .then(
                      //   setTimeout(() => {
                      //     //index === (readings.length - 1) && closeWindow();
                      // }, delay))
                    },
                    margin: [0,10,0,10],
                    x: 10,
                    y: 15,
                    autoPaging: 'text',
                    html2canvas: {useCORS: true, scale: 0.505
                      , height: 0 },
                  })
                
              }).catch((e)=>{
                showNotification({
                    message: e, 
                    icon: RedCross
                });
              });
        }
        this.setState({files});
        setTimeout(() => {
            this.printDocument(index+1, count+1);  
        }, delay);
    }else{
        downloadStatus.textContent=`PDF-Dokumente zusammenfügen ...`;
        setTimeout(() => {
            const pdfBytes = this.mergePdfs(this.state.files);
            pdfBytes.then(function(result) {
                var blob = new Blob([result], {type: "application/pdf"});
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                //var fileName = reportName;
                let tenantReading = readings.find((reading)=> reading.id === occupationReadings[0].readingsId && occupationReadings[0].occupationId === reading.occupationId);
                let fileName = occupationReadings !== undefined && occupationReadings.length === 1 ? 
                `Ableseprotokoll-${propertyName}-(${moment(readings[index-1]?.periodStart).format('DD.MM.YYYY') + ' - ' + moment(readings[index-1]?.periodEnd).format('DD.MM.YYYY')})-${tenantReading !== undefined && tenantReading.tenantFullName ? tenantReading?.tenantFullName : ''}-${tenantReading !== undefined ? printOccasion(tenantReading?.occasion) : ''}.pdf` 
                : `Ableseprotokoll-${propertyName}-(${moment(readings[index-1]?.periodStart).format('DD.MM.YYYY') + ' - ' + moment(readings[index-1]?.periodEnd).format('DD.MM.YYYY')}).pdf`
                link.download = fileName;
                link.click();
                setTimeout(() => {
                    closeWindow();
                }, 500);
            })
            console.log('pdfBytes: ', pdfBytes);
        }, delay);
    }
}

downloadPdfFromServer=(count)=>{
  const {meterReadingsSwitch, compositionOfHeatingCostsSwitch, costSplitWarmWaterAndHeatingSwitch, splitBaseConsumptionCostsSwitch, energyConsumptionCO2EmissionsSwitch, compareHeatingConsumptionBarChartSwitch, energyLevelsInfoSwitch, arbitraryBoardInfoSwitch, energyAdviceCenterInfoSwitch, co2TaxInfoSwitch, heatingFilter, readings, occupationReadings} = this.state;
  const {messagePreview=false, getPdfUrl} = this.props;
  let propertyName = this.props.currentProperty.name;

  const printOccasion = (slug) => {
    switch (slug) {
      default: case 'annual':
        return 'Jahresablesung';
      case 'move-in':
        return 'Einzug';
      case 'move-out':
        return 'Auszug';
    }
  }

  var downloadStatus = document.getElementById('download_status');
  const closeWindow = ()=> {
    var allowDownloadSafari = document.getElementById('allow_download');
    allowDownloadSafari.style.display = browserName === 'Safari' && 'block'; 
    var spinner = document.getElementById('hh_loader_spinner');
    browserName !== 'Safari' ? loader(false) : spinner.style.display = 'none';
    browserName !== 'Safari' && window.close();
  }
  const downloadPage=()=>{
    const data = new FormData();
    let html = document.getElementById(`divToPrint${count}`);
    console.log('html: ', html, count);
    let doc = document.implementation.createHTMLDocument("New Document");
    try {
      const {accountData, propertySelected, currentSubscription} = this.props;
      doc.body.appendChild(html);
      const blob = new Blob([doc.documentElement.innerHTML], {
        type: 'text/html'
      });
      
      const fileName = `billingstatement-${this.props.propertySelected.name}-${new Date().valueOf()}}`;
      let file = new File([blob], fileName);
      file.originalname = fileName;
      console.log('downloadPdfFromServer: ', file);

      data.append('file', file);
      data.append('isPageNumberInHeaderEnabled', false);
      //!isStarterTier(this.props.currentSubscription) && data.append('footer', `${this.props.accountData.addressCompany && (this.props.accountData.addressCompany + ', ')}${this.props.accountData.addressStreet && (this.props.accountData.addressStreet + ',')} ${(this.props.accountData.addressZipCode)} ${this.props.accountData.addressCity}`);
      if(!isStarterTier(currentSubscription)){
        let footer = `${accountData.addressCompany && (accountData.addressCompany + ', ')}${accountData.addressStreet && (accountData.addressStreet + ',')} ${(accountData.addressZipCode)} ${accountData.addressCity}`;
        console.log('propertySelectedsadfadg: ', propertySelected);
        if(propertySelected?.isPropertyOwnerInfoEnabled && propertySelected?.isPropertyOwnerInfoInMessagesEnabled){
          const {propertyOwner} = propertySelected;
          footer = `${propertyOwner?.name && (propertyOwner?.name + ', ')}${propertyOwner?.street && (propertyOwner?.street + ', ')}${(propertyOwner?.postalCode)} ${propertyOwner?.city}`;
          data.append('footer', footer);
        }else{
          data.append('footer', footer);
        }
      }
      let url = `https://${checkEnvironment()}.hellohousing.de/api/reporting-api/pdf`;
      fetch(url,
        {
          method: 'POST',
          body: data,
          headers: {
            Authorization: Autoload.Utils.getAuthToken(),
          }
        }).then((response)=> {
          if(response.status === 200){
            response.blob()
            .then(data => {
              
              //download progress
              // var a = document.createElement("a");
              // document.body.appendChild(a);
              // let url = window.URL.createObjectURL(data);
              // a.href = url;
              // a.download = 'test.pdf';
              // a.click();
              // window.URL.revokeObjectURL(url);
  
              downloadStatus.textContent=`PDF-Dokumente erstellen ${count > readings.length ? readings.length : count+1} / ${readings.length}`;
              this.convertBlobToArrayBuffer(data).then((value)=> {
                let {allPdfs} = this.state;
                allPdfs.push(value);
                this.setState({allPdfs});
                this.downloadPdfFromServer(count+1);  
              })
              
            })
          }else{
            errorHandlingForPDF(response, this.props.profileData, url);
          }
        });
    } catch (e) {
      console.error('downloadPage: ', e);
    }
  }
  if(count < readings.length) {
    downloadPage();
  }else{
    downloadStatus.textContent=`PDF-Dokumente zusammenfügen...`;
    setTimeout(() => {
      const pdfBytes = this.mergePdfs(this.state.allPdfs);
      pdfBytes.then(function(result) {
        var blob = new Blob([result], {type: "application/pdf"});
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        //var fileName = reportName;
        let tenantReading = readings.find((reading)=> reading.id === occupationReadings[0].readingsId && occupationReadings[0].occupationId === reading.occupationId);
        let fileName = occupationReadings !== undefined && occupationReadings.length === 1 ? 
        `Ableseprotokoll-${propertyName}-(${moment(readings[count-1]?.periodStart).format('DD.MM.YYYY') + ' - ' + moment(readings[count-1]?.periodEnd).format('DD.MM.YYYY')})-${tenantReading !== undefined && tenantReading.tenantFullName ? tenantReading?.tenantFullName : ''}-${tenantReading !== undefined ? printOccasion(tenantReading?.occasion) : ''}.pdf` 
        : `Ableseprotokoll-${propertyName}-(${moment(readings[count-1]?.periodStart).format('DD.MM.YYYY') + ' - ' + moment(readings[count-1]?.periodEnd).format('DD.MM.YYYY')}).pdf`
        link.download = fileName;
        link.click();
        setTimeout(() => {
            closeWindow();
        }, 500);
      })
    }, 1000);
  }
}

convertToBase64= async (data)=>{
  try {
      var reader = new FileReader();
      reader.readAsDataURL(data); 

      const setState=(base64)=>{
        console.log('setState_base64: ', base64);
      // this.setState({customImageBase64: base64 ? base64 : null});
        return base64;
      }
      
      reader.onloadend = function() {
      var base64data = reader.result;                
      console.log('base64data: ', base64data);
      setState(base64data);
      }
  } catch (error) {
      console.log('convertToBase64Error: ', error);
  }
}

async convertBlobToArrayBuffer(blob) {
  console.log('convertBlobToArrayBuffer', blob);
  const buf = await blob.arrayBuffer();
  return buf;
}

saveByteArray(reportName, byte) {
    var blob = new Blob([byte], {type: "application/pdf"});
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    var fileName = reportName;
    link.download = fileName;
    link.click();
};


async mergePdfs(pdfsToMerge) {
  console.log('mergePdfs', pdfsToMerge);
  const mergedPdf = await PDFDocument.create();
  const font = await mergedPdf.embedStandardFont(StandardFonts.Helvetica);

const createInnerPromise = async (arrayBuffer) => {
  const pdf = await PDFDocument.load(arrayBuffer);
  return await mergedPdf.copyPages(pdf, pdf.getPageIndices());
};

const outerPromise = pdfsToMerge.map((arrayBuffer) => {
  const innerPromise = createInnerPromise(arrayBuffer);
  return innerPromise;
});

const resultOuterPromise = await Promise.all(outerPromise);

let count = 0;
let totalPages = 0;
resultOuterPromise.forEach((pageArray, i) => {
  pageArray.forEach((page, index) => {
    totalPages = totalPages + 1;
  })
});
resultOuterPromise.forEach((pageArray, i) => {
  pageArray.forEach((page) => {
    const { width, height } = page.getSize();
    page.drawText(`Seite ${count+1} von ${totalPages}`, {
      x: width - 75.5,
      y: height - 34, //height - 47,
      size: 6,
      color: rgb(0.4470588235294118, 0.4470588235294118, 0.5803921568627451),
    })

    //add footer
    // var text = `${this.props.accountData.addressCompany && (this.props.accountData.addressCompany + ', ')}${this.props.accountData.addressStreet && (this.props.accountData.addressStreet + ',')} ${(this.props.accountData.addressZipCode)} ${this.props.accountData.addressCity}`;
    // const textWidth = font.widthOfTextAtSize(text, 8);
    // !isStarterTier(this.props.currentSubscription) && page.drawText(text, {
    //   x: page.getWidth() / 2 - textWidth / 2,
    //   y: height - (height-30),
    //   size: 8,
    //   color: rgb(0, 0, 0)//rgb(0.5, 0.5, 0.5)
    // })
    //
    mergedPdf.addPage(page);
    count = count + 1;
  });
});

return (await mergedPdf.save()).buffer;
}

// async mergePdfs(pdfsToMerge) {
//     console.log('mergePdfs', pdfsToMerge);
//     const mergedPdf = await PDFDocument.create();

//   const createInnerPromise = async (arrayBuffer) => {
//     const pdf = await PDFDocument.load(arrayBuffer);
//     return await mergedPdf.copyPages(pdf, pdf.getPageIndices());
//   };

//   const outerPromise = pdfsToMerge.map((arrayBuffer) => {
//     const innerPromise = createInnerPromise(arrayBuffer);
//     return innerPromise;
//   });

//   const resultOuterPromise = await Promise.all(outerPromise);

//   resultOuterPromise.forEach((pageArray) => {
//     pageArray.forEach((page) => {
//       mergedPdf.addPage(page);
//     });
//   });

//   return (await mergedPdf.save()).buffer;
//   }

// async printDocumentMultiplePages() {
//     const {readings, readingsId} = this.state;
//     let delay = readings.length * 1000;
//     const logo = document.getElementById('logo');
//     let divToPrint = document.getElementById('divToPrint');
//     console.log('printDocument');
//     const closeWindow = ()=> {
//       var allowDownloadSafari = document.getElementById('allow_download');
//       allowDownloadSafari.style.display = browserName === 'Safari' && 'block'; 
//       var spinner = document.getElementById('hh_loader_spinner');
//       browserName !== 'Safari' ? loader(false) : spinner.style.display = 'none';
//       browserName !== 'Safari' && window.close();
//     }
//         // let input = document.getElementById(`divToPrint${index}`);
//         // let printOccassion = this.printOccasion(reading?.occasion);
//             // if(readingsId.includes(reading.id)){
//                 await html2canvas(logo, {
//                     scale: 4
//                 }).then(async(canvas) => {
//                     const imgData = canvas.toDataURL('image/png');
//                     var doc = new jsPdf("p", "pt", 'a4');
//                     var imgHeight = canvas.height;
//                     var height = doc.internal.pageSize.getHeight();
//                     console.log('pageHeight: ', height);
//                     doc.addImage(imgData, 'JPEG',21, 20, 75,38, undefined, 'NONE');
//                     await readings.forEach((_, index)=> {
//                         var div = document.getElementById(`divToPrint${index}`);
//                         var clientHeight = div.clientHeight;
//                         console.log('clientHeight: ', logo.clientHeight);
//                         if(index !== 0){ //(readings.length -1)
//                             div.style.marginTop = `${height + logo.clientHeight}pt`;
//                         }
//                     })
//                     await readings.forEach((_, index)=>{
//                         index !== 0 && doc.addPage('a4', 'p');
//                         index !== 0 && doc.addImage(imgData, 'JPEG',21, 20, 75,38, undefined, 'NONE');
//                     })
                    
                    
//                     doc.html(divToPrint, {
//                     callback: function (doc) {
//                         doc.save('test.pdf', {returnPromise: true})
//                         .then(
//                         setTimeout(() => {
//                             //closeWindow();
//                         }, 500))
//                     },
//                     margin: [0,10,0,10],
//                     x: 10,
//                     y: 15,
//                     autoPaging: 'text',
//                     html2canvas: {useCORS: true, scale: 0.505
//                         , height: 0 },
//                     })
//                 });
//             // }
    
// }

  render() {
    // hellohousing's logo, or a partner's while the account has a partner plan (#2357).
    const defaultLogo = getPdfDefaultLogo(this.props.currentSubscription, Logo, this.props.accountData);
    // const data = this.getAllData();
    // const balance = this.calculateBalance(data);
    const { showEmpty, utilityData, utilityBillTableData, readingsId, readings, count, customImageBase64 } = this.state;
    const {isLogoHidden} = this.props;
    console.log(utilityData);
    const pageHeight = 841.89;
    // Encode the SVG as base64
    //console.log('b64: ', b64);
    // const data = {
    //     currentTenant:{},
    //     allTenantBills:[]
    // };
    // if ((Object.keys(data.currentTenant).length == 0 && data.allTenantBills.length == 0) || showEmpty) {
    //   return <EmptyStateContainer heading={lang.utility.text_no_tenant_bills} icon={tap} showBtn={false} />;
    // }
    console.log('count: ', count);
    console.log('readings: ', readings);
    console.log('files: ', this.state.files)
    return (
      <>
      <div>
        <img src={this.props.companyLogoEnable ? this.props.accountData.pictureLocation !== null ? this.props.accountData.pictureLocation : defaultLogo : defaultLogo} id='logo' alt="logo" style={{height: this.props.companyLogoEnable === 'UserDefined' && this.props.accountData.pictureLocation !== null && 38}}/>
      </div>
      <div id={'divToPrint'} style={{ overflow: 'auto' }}>
        {/* <div style={{ marginBottom: 48 }}>
              <img src={Logo} id='logo' alt="logo" />
        </div> */}
        {/* <ReactToPdf targetRef={ref} filename="billing-statement.pdf" scale={0.65} onComplete={() => {
          // setTimeout(() => {
          //   window.close()
          // }, 1000);
        }} >
          {({ toPdf }) => (
            <button style={{ display: 'none' }} onClick={toPdf}>Generate pdf</button>
          )}
        </ReactToPdf> */}
        {/* <button onClick={this.printDocument}>Generate pdf</button> */}
        {/* <div style={{ width: '100vw', height: '100vh', position: 'absolute', zIndex: 1000, background:'red' }}></div> */}
          {readings &&
        readings.sort((a,b)=> new Date(a.occasionDate) - new Date(b.occasionDate))
        //.sort((a,b)=> a.rentalUnitName.toLowerCase().localeCompare(b.rentalUnitName.toLowerCase()))
        .sort((a,b)=> (b.rentalUnitName === null) - (a.rentalUnitName === null) || (a.rentalUnitName?.toLowerCase().localeCompare(b.rentalUnitName?.toLowerCase())))
        .map((reading, index) => 
        <div
            ref={ref}
            id={`divToPrint${index}`}
            style={{fontFamily: 'Inter,sans-serif', maxWidth: '186mm', width: '100%',}}
          >
            {isLogoHidden === false ?
            <div style={{ marginBottom: 48 }}>
              <img src={this.props.companyLogoEnable === 'UserDefined' ? customImageBase64 !== null ? customImageBase64 : defaultLogo : defaultLogo} //id='logo' 
              alt="logo" style={{height: this.props.companyLogoEnable === 'UserDefined' && this.props.accountData.pictureLocation !== null ? '62.5px' : '56px'}}/>
            </div>
            :
            <div style={{marginBottom: 48}}/>}
            <div style={{ marginBottom: 38}}>
              <span style={{fontWeight: '500', fontSize: '17pt'}}>Ableseprotokoll</span>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'start', alignItems: 'flex-start' }}>
              <div style={{ width: "20%", display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <p style={{ fontSize: '7pt', marginBottom: '0mm', color: '#767676' }}>Einheit</p>
                <p style={{ fontSize: '7.5pt', marginBottom: '2mm', overflow: 'hidden', whiteSpace: 'normal', textOverflow: 'ellipsis' }}>
                  {reading?.rentalUnitName ? reading?.rentalUnitName : '-'}
                </p>
              </div>
              <div style={{ width: "20%", display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <p style={{ fontSize: '7pt', marginBottom: '0mm', color: '#767676' }}>Mieter</p>
                <p style={{ fontSize: '7.5pt', marginBottom: '2mm', overflow: 'hidden', whiteSpace: 'normal', wordBreak: 'break-all', textOverflow: 'ellipsis', width: '85%' }}>
                  {reading?.tenantFullName ? reading?.tenantFullName : '-'}
                </p>
              </div>
              <div style={{ width: "20%", display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <p style={{ fontSize: '7pt', marginBottom: '0mm', color: '#767676' }}>Ableseanlass</p>
                <p style={{ fontSize: '7.5pt', marginBottom: '2mm', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  {(reading?.vacant && reading?.occasion === 'move-in') ? '-' : this.printOccasion(reading?.occasion)}
                </p>
              </div>
              <div style={{ width: "20%", display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <p style={{ fontSize: '7pt', marginBottom: '0mm', color: '#767676' }}>Ablesedatum</p>
                <p style={{ fontSize: '7.5pt', marginBottom: '2mm', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  {reading?.occasion === 'empty-tenant-move-out' ? moment(reading?.periodEnd).format('DD.MM.YYYY') : moment(reading?.occasionDate).format('DD.MM.YYYY')}
                </p>
              </div>

              <div style={{ width: "20%", display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <p style={{ fontSize: '7pt', marginBottom: '0mm', color: '#767676' }}>Ablesungszeitraum</p>
                <p style={{ fontSize: '7.5pt', marginBottom: '2mm', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  {moment(reading?.periodStart).format('DD.MM.YYYY') + ' - ' + moment(reading?.periodEnd).format('DD.MM.YYYY')}
                </p>
              </div>
            </div>
            <>
              {reading.meterReadings.length !== 0 ?
              <TableContainer component={Paper} 
              style={{marginTop: '20px', background: 'transparent'}}>
                <Table //className={`table borderless mb-0 ub-table`} 
                style={{width: '100%', //borderBottom: '1px solid #DADAE6', 
                wordBreak: 'break-word',
                borderCollapse: 'collapse'}} 
                >
                  <TableHead style={{border: '1px solid #DADAE6', borderBottom: 'none', borderTop: 'none', borderLeft: 'none'}}>
                    {this.getTableLabels(reading?.occasion === 'move-in')}
                  </TableHead>
                  <TableBody 
                  //className="ub-body"
                  style={{background: 'white', borderLeft: 'none'}}
                  >
                    {reading.meterReadings.sort((a,b)=> a.meter.meterNo.localeCompare(b.meter.meterNo))
                    .sort((a, b) => a.meter.allocationKey.allocationKeyName.localeCompare(b.meter.allocationKey.allocationKeyName))
                    .map((meterReading, subIndex) => {
                        const hkEnabled= (meterReading.meter.allocationKey.systemAllocationKeyId === '17749a71-7aa8-4920-9773-b6c218504ba3' && meterReading.meter.isHKAAnnuallyResetEnabled && (reading?.occasion === 'annual' || reading?.occasion === 'move-out') && reading?.startReadingOccasion === 'annual') ? true : false;          
                        const hkEvanluationFactor = meterReading.meter.hkaEvaluationFactor;
                        //const consumption = (meterReading.currentValue !== null && hkEnabled) ? meterReading.currentValue - 0 : (meterReading.startValue?.value !== null && meterReading.currentValue !== null) ? meterReading.currentValue - meterReading.startValue?.value : null; // Just calculate consumption
                        // const startValue = hkEnabled ? 0 : meterReading.startValue !== null ? meterReading.startValue ? meterReading.startValue : 0 : null;
                        
                        // const currentValue = meterReading.currentValue !== null ? meterReading.currentValue ? meterReading.currentValue : 0 : null;

                        // const consumption = (hkEnabled && currentValue) ? currentValue - 0 : meterReading.consumption !== null ? meterReading.consumption ? meterReading.consumption : 0 : null;

                        const startValue = hkEnabled ? 0 : 
                        (hkEvanluationFactor !== null && meterReading?.startValue?.value) ? (meterReading?.startValue?.value * hkEvanluationFactor) : 
                        meterReading?.startValue?.value !== null ? meterReading?.startValue?.value ? meterReading?.startValue?.value : 0 : null;
                        
                        const currentValue = (hkEvanluationFactor !== null && meterReading.currentValue) ? (meterReading.currentValue * hkEvanluationFactor) :
                        meterReading.currentValue !== null ? meterReading.currentValue ? meterReading.currentValue : 0 : null;

                        const consumption = (hkEnabled && meterReading.currentValue !== null) ? meterReading.currentValue - 0 :
                        (hkEvanluationFactor !== null && currentValue && startValue) ? (currentValue - startValue) : 
                        meterReading.consumption !== null ? meterReading.consumption ? meterReading.consumption : 0 : null;

                        console.log('consumption: ', consumption);
                        
                        if(subIndex === 0){
                            this.allocationKey = meterReading.meter.allocationKey.allocationKeyName;
                            this.allocationKeyValueTotal = ((hkEnabled && currentValue) ? currentValue - 0 : consumption);
                            this.allocationKeyUnit = meterReading.meter.allocationKey.systemAllocationKeyId === '17749a71-7aa8-4920-9773-b6c218504ba3' ? (hkEvanluationFactor !== null ? 'Einheits- / Produktskala' : 'Produktskala') : meterReading.meter.allocationKey.units;
                            this.allocationCounter = 1;
                            console.log('else if:  index === 0');
                            return (
                                <MeterReadingsTableRow 
                                rowReading={meterReading} 
                                subIndex={subIndex} 
                                occasionDate={reading.occasionDate}
                                consumption={consumption} 
                                end={reading?.occasion === 'move-in'} 
                                key={subIndex} 
                                startValue={meterReading.startValue}
                                currentValue={meterReading.currentValue}
                                print={true}
                                hkEnabled={hkEnabled}
                              />
                            );
                        } else if(this.allocationKey !== meterReading.meter.allocationKey.allocationKeyName){
                            let value = this.allocationKeyValueTotal;
                            let allocationKey = this.allocationKey;
                            let unit = this.allocationKeyUnit;
                            let counter = this.allocationCounter;
                            this.allocationKey = meterReading.meter.allocationKey.allocationKeyName;
                            this.allocationKeyValueTotal = ((hkEnabled && currentValue) ? currentValue - 0 : consumption);
                            this.allocationKeyUnit = meterReading.meter.allocationKey.systemAllocationKeyId === '17749a71-7aa8-4920-9773-b6c218504ba3' ? (hkEvanluationFactor !== null ? 'Einheits- / Produktskala' : 'Produktskala') : meterReading.meter.allocationKey.units;
                            this.allocationCounter = 1;
                            console.log('value: ', value);
                            return (
                                <>
                                {reading.occasion !== 'move-in' &&
                                <TableRow>
                                    <TableCell colSpan={6} style={{...tableBodyCellStyling, ...{textAlign: 'right', border: '1px solid #DADAE6', fontWeight: '500', borderRight: 'none'}}}>
                                        {`Gesamt ${allocationKey}`}
                                    </TableCell>
                                    <TableCell style={{...tableBodyCellStyling, ...{textAlign: 'right', border: '1px solid #DADAE6', fontWeight: '500', borderRight: 'none'}}}>
                                        {value ? accounting.formatNumber(value, 2, '.', ',') : ''}
                                    </TableCell>
                                    <TableCell colSpan={2} style={{...tableBodyCellStyling, ...{border: '1px solid #DADAE6', fontWeight: '500', whiteSpace: 'normal'}}}>
                                        {formatUnit(unit)}
                                    </TableCell>
                                </TableRow>}
                                <MeterReadingsTableRow 
                                rowReading={meterReading} 
                                subIndex={subIndex} 
                                occasionDate={reading.occasionDate}
                                consumption={consumption} 
                                end={reading.occasion === 'move-in'} 
                                key={subIndex} 
                                startValue={meterReading.startValue}
                                currentValue={meterReading.currentValue}
                                print={true}
                                hkEnabled={hkEnabled}
                              />
                              </>
                            );
                            
                        } else {
                            this.allocationKeyValueTotal = this.allocationKeyValueTotal + ((hkEnabled && currentValue) ? currentValue - 0 : consumption);
                            this.allocationCounter = this.allocationCounter + 1;
                            console.log('else: ');
                            return (
                                <MeterReadingsTableRow 
                                rowReading={meterReading} 
                                subIndex={subIndex} 
                                occasionDate={reading.occasionDate}
                                consumption={consumption} 
                                end={reading.occasion === 'move-in'} 
                                key={subIndex} 
                                startValue={meterReading.startValue}
                                currentValue={meterReading.currentValue}
                                print={true}
                                hkEnabled={hkEnabled}
                              />
                            );
                        }

                        
                      })
                    }
                    {reading.occasion !== 'move-in' &&
                    <TableRow>
                        <TableCell colSpan={6} style={{...tableBodyCellStyling, ...{textAlign: 'right', border: '1px solid #DADAE6', fontWeight: '500', borderRight: 'none'}}}>
                            {`Gesamt ${this.allocationKey}`}
                        </TableCell>
                        <TableCell style={{...tableBodyCellStyling, ...{textAlign: 'right', border: '1px solid #DADAE6', fontWeight: '500', borderRight: 'none'}}}>
                            {this.allocationKeyValueTotal ? accounting.formatNumber(this.allocationKeyValueTotal, 2, '.', ',') : '-'}{/* {this.allocationKeyValueTotal ? Autoload.MainHelper.ConverterCurrencyDe_DisplayOnly(this.allocationKeyValueTotal.toString() + '', false) : ''} */}
                        </TableCell>
                        <TableCell colSpan={2} style={{...tableBodyCellStyling, ...{border: '1px solid #DADAE6', fontWeight: '500', whiteSpace: 'normal'}}}>
                            {formatUnit(this.allocationKeyUnit)}
                        </TableCell>
                    </TableRow>}
                  </TableBody>
                </Table>
              </TableContainer>
              :
                // <div id='emptyState'>
                //     <div>
                //         <div>
                //             <div className="main-container empty-state-container">
                //             <div className="icon-container" style={{background: 'transparent'}}>
                //                 <img id='emptyLogo' src={MeterIcon} className="empty-state-icon" alt="empty" />
                //             </div>
                //             <h4 style={{fontSize: 16, fontFamily: 'Inter, sans-serif'}} className="empty-state-heading">{'Der Einheit sind keine Zähler zugeordnet.'}</h4>
                //             {/* <h5 style={{fontSize: 14, fontFamily: 'Inter, sans-serif'}} className="empty-state-subheading">{'Bitte legen Sie Zähler an bevor Sie mit der Ablesung beginnen.'}</h5> */}
                //             </div>
                //         </div>
                //     </div>
                // </div>
                <div id='emptyStateMeterReadings' style={{marginTop: '120px'}}>
                  <div>
                      <div>
                          <div className="main-container empty-state-container" style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                            <div className="icon-container" style={{background: 'transparent', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', borderRadius: '4px'}}>
                                <img id='emptyLogoMeter' src={MeterIcon} className="empty-state-icon" style={{margin: '12px'}} alt="empty" />
                            </div>
                            <div style={{marginTop: '20px'}}>
                              <span style={{
                                marginTop: '16px',
                                fontFamily: 'Inter, sans-serif',
                                fontStyle: 'normal',
                                fontWeight: '500',
                                fontSize: '11px',
                                lineHeight: '20px',
                                color: 'rgb(19, 19, 92, 0.8)'
                              }} className="empty-state-heading">{'Der Einheit sind keine Zähler zugeordnet.'}</span>
                            </div>
                            {/* <div style={{marginTop: '12px'}}>
                              <span style={{
                                marginTop: '0px',
                                marginBottom: '12px',
                                fontStyle: 'normal',
                                fontWeight: '400',
                                fontSize: '10px',
                                lineHeight: '16px',
                                color: 'rgb(114, 114, 147, 0.6)',
                                fontFamily: 'Inter, sans-serif',
                                textAlign: 'center'
                              }} className="empty-state-subheading">{'Bitte legen Sie Zähler an bevor Sie mit der Ablesung beginnen.'}</span>
                            </div> */}
                          </div>
                      </div>
                  </div>
                </div>
                }
            </>
          </div>)}
      </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  // console.log('stateee', state.UtilityBillingReducer)
  return {
    // allUtilityBills: state.UtilityBillingReducer.utilityBillingData,
    propertySelected: state.generalReducer.property, 
    currentProperty: state.generalReducer.property,
    currentDataId: state.UtilityBillingReducer.currentBillingId,
    tenantBills: state.UtilityBillingReducer.utilityBillingData,
    utilityBillingData: state.UtilityBillingReducer.utilityBillingData,
    selectedMeterReadings: state.generalReducer.meterReadingsToPrint,
    companyLogoEnable: state.generalReducer.companyLogoEnable,
    accountData: state.generalReducer.accountData,
    currentSubscription: state.generalReducer.currentSubscription,
    isLogoHidden: state.generalReducer.isLogoHidden,
    profileData: state.generalReducer.profile
  };
};

const mapDispatchToProps = {
  setTenantBills,
};

export default connect(mapStateToProps, mapDispatchToProps)(MeterReadingsTemplate);